class GLBCacheManager {
    constructor(dbName = 'GLBCache', storeName = 'models', version = 1) {
        this.dbName = dbName;
        this.storeName = storeName;
        this.version = version;
        this.db = null;
    }

    async open() {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open(this.dbName, this.version);
            request.onerror = () => reject("Error opening database");
            request.onsuccess = (event) => {
                this.db = event.target.result;
                resolve();
            };
            request.onupgradeneeded = (event) => {
                const db = event.target.result;
                db.createObjectStore(this.storeName);
            };
        });
    }

    async getGLB(key) {
        return new Promise((resolve, reject) => {
            const transaction = this.db.transaction([this.storeName], 'readonly');
            const store = transaction.objectStore(this.storeName);
            const request = store.get(key);
            request.onerror = () => reject("Error retrieving GLB file");
            request.onsuccess = () => resolve(request.result);
        });
    }

    async storeGLB(key, arrayBuffer) {
        return new Promise((resolve, reject) => {
            const transaction = this.db.transaction([this.storeName], 'readwrite');
            const store = transaction.objectStore(this.storeName);
            const request = store.put(arrayBuffer, key);
            request.onerror = () => reject("Error storing GLB file");
            request.onsuccess = () => resolve();
        });
    }
}

export default GLBCacheManager;